/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers200,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers401,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers404,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersPathParams,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersQueryParams,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersQueryResponse,
} from "../../types/classPlanningFeedbacksController/GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers.ts";
import { feedbackAnswerListItemViewModelSchema } from "../feedbackAnswerListItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    feedbackId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersPathParams>;

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersQueryParamsSchema =
  z
    .object({
      PageNumber: z.optional(z.coerce.number().int()),
      PageSize: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers200Schema =
  z.array(
    z.lazy(() => feedbackAnswerListItemViewModelSchema),
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers404>;

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswers200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidAnswersQueryResponse>;
